import { createContext, useContext, useEffect, useState } from "react"
import {
    collection,
    query,
    where,
    getDocs
} from "firebase/firestore"
import { db } from "../firebase"
import { AuthContext } from "./AuthContext"

const ChatListingsContext = createContext()
// const ChatListingUpdateContext = createContext()

export function useChatListingsContext() {
    return useContext(ChatListingsContext)
}

// export function useChatListingsUpdate() {
//     return useContext(ChatListingsContext)
// }
    
export const ChatListingsContextProvider = ({ children }) => {
    const { currentUser } = useContext(AuthContext)
    console.log(currentUser.activeChats)
    const [buyingListings, setBuyingListings] = useState(null)
    const [sellingListings, setSellingListings] = useState(null)
    const [patronUsers, setPatronUsers] = useState(null)

    const getChatListings = async() => {
        const buyingListingIds = currentUser.activeChats.buying.map(chat => chat.listingId)
        const sellingListingIds = currentUser.activeChats.selling.map(chat => chat.listingId)
        // const listingIds = [...buyingListingIds, ...sellingListingIds]
        if (buyingListingIds.length > 0) {
            try {
                const q = query(
                    collection(db, "listings"), where("id", "in", buyingListingIds)
                )
                const buyingQuerySnapshot = await getDocs(q)
                const buyingQueryRes = []
                buyingQuerySnapshot.forEach((doc) => {
                    const docData = doc.data()
                    buyingQueryRes.push(docData)
                })
                setBuyingListings(buyingQueryRes)
                // console.log("buying listings", buyingQueryRes)
            } catch(err) {
                console.error(err.message)
            }
        }

        if (sellingListingIds.length > 0) {
            try {
                const q = query(
                    collection(db, "listings"), where("id", "in", sellingListingIds)
                )
                const sellingQuerySnapshot = await getDocs(q)
                const sellingQueryRes = []
                sellingQuerySnapshot.forEach((doc) => {
                    const docData = doc.data()
                    sellingQueryRes.push(docData)
                })
                setSellingListings(sellingQueryRes)
                // console.log("selling listings", sellingQueryRes)
            } catch(err) {
                console.error(err.message)
            }
        }

        const buyers = currentUser.activeChats.selling.map(chat => chat.buyingUser)
        if (buyers.length > 0) {
            try {
                const q = query(
                    collection(db, "users"), where("uid", "in", buyers)
                )
                const querySnapshot = await getDocs(q)
                const queryRes = {}
                querySnapshot.forEach((doc) => {
                    const docData = doc.data()
                    queryRes[doc.id] = docData.firstName
                })
                setPatronUsers(queryRes)
                // console.log("patronUsers", queryRes)
            } catch(err) {
                console.error(err.message)
            }
        }
    }

    // const updateListings = (newListingsArray) => {
    //     setListings(newListingsArray)
    //     console.log("listings updated to", newListingsArray)
    // }

    // useEffect(() => {
    //     getChatListings()
    // }, [])

    return (
        <ChatListingsContext.Provider value={ {buyingListings, sellingListings, patronUsers} }>
            {children}
        </ChatListingsContext.Provider>
    )

}